{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/post-navigation-link",
	"title": "Post Navigation Link",
	"category": "theme",
	"description": "Displays the next or previous post link that is adjacent to the current post.",
	"textdomain": "default",
	"attributes": {
		"type": {
			"type": "string",
			"default": "next"
		},
		"label": {
			"type": "string",
			"role": "content"
		},
		"showTitle": {
			"type": "boolean",
			"default": false
		},
		"linkLabel": {
			"type": "boolean",
			"default": false
		},
		"arrow": {
			"type": "string",
			"default": "none"
		},
		"taxonomy": {
			"type": "string",
			"default": ""
		}
	},
	"usesContext": [ "postType" ],
	"supports": {
		"anchor": true,
		"reusable": false,
		"html": false,
		"color": {
			"link": true
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"textAlign": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalWritingMode": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"shadow": {
			"__experimentalSkipSerialization": true
		},
		"interactivity": {
			"clientNavigation": true
		},
		"spacing": {
			"__experimentalSkipSerialization": true,
			"margin": true,
			"padding": true,
			"__experimentalDefaultControls": {
				"margin": false,
				"padding": false
			}
		},
		"__experimentalBorder": {
			"__experimentalSkipSerialization": true,
			"color": true,
			"radius": true,
			"style": true,
			"width": true,
			"__experimentalDefaultControls": {
				"color": false,
				"radius": false,
				"style": false,
				"width": false
			}
		}
	},
	"selectors": {
		"border": ".wp-block-post-navigation-link:not(:empty)",
		"shadow": ".wp-block-post-navigation-link:not(:empty)",
		"spacing": ".wp-block-post-navigation-link:not(:empty)"
	},
	"style": "wp-block-post-navigation-link"
}
